webpackJsonp([12],{

/***/ "/xfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDisableTrackM; });
/** 是否关闭埋点上报 */
var isDisableTrackM = function isDisableTrackM() {
  // const domain = window.location.host;
  // return ["www.oytraining.top", "www.kpgohg.top", "www.fatml.top", "localhost"].includes(domain);
  return true;
};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Qg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "44dg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("3Qg8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e1ab3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("S6md");
function injectStyle (ssrContext) {
  __webpack_require__("j1Ai")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2e1ab3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e1ab3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "80l2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BK/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    // hostUrl: 'https://tmp.tw51buygobuy.com',//本地验证使用
    // 服务器地址
    hostUrl: __webpack_require__.i({"NODE_ENV":"production","STATIC_CDN":"https://duw6x15mey27a.cloudfront.net"}).API_ROOT || window.location.origin,
    // 图片的cdn地址，仅用于接口上传
    cdnUrl: 'https://d1q4aqp7bomo9e.cloudfront.net/Public',
    // 客服地址
    //msgUrl: 'https://www.facebook.com/messages/t/113690220462833',
    msgUrl: 'https://m.me/113690220462833?ref=' + encodeURIComponent(location.href),
    // msgUrl: 'https://m.me/103018364497776?ref=' + encodeURIComponent(location.href),
    // 初始加载图
    loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC'
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f304684a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("oI02");
function injectStyle (ssrContext) {
  __webpack_require__("80l2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f304684a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__http_api_js__ = __webpack_require__("m4jk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css__ = __webpack_require__("d8/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_config__ = __webpack_require__("BK/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_index_css__);





 //vuex
 //http请求
 //移动端UI






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui___default.a, {
  lazyload: {
    loading: __WEBPACK_IMPORTED_MODULE_10__util_config__["a" /* default */].loading
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_6__http_api_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a.config.autoSetContainer = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui___default.a);

// 设置cl值
// 台湾：tw_tc
// 泰国：th_th
// 马来(中文)：my_cn
// 马来(英文)：my_en
// 新加坡(中文)：sg_cn
// 新加坡(英文)：sg_en
// 香港(中文)：hk_tc
// 香港(英文)：hk_en
// 日本：jp_jp
// 阿联酋：ua_ar
// 沙特阿拉伯：sa_ar
// 罗马尼亚：ro_ro

var templateConfigs = {
  'tw_tc': {
    country: '台湾',
    stateSelect: true,
    citySelectInline: true,
    serviceLineMe: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '台湾'

  },
  'th_th': {
    country: '泰国',
    stateSelect: true,
    citySelect: true,
    thAddress: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '泰国'
  },
  'th_en': {
    country: '泰国',
    stateSelect: true,
    citySelect: true,
    thAddress: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '泰国'
  },
  'my_cn': {
    country: '马来西亚',
    stateSelect: true,
    citySelectInline: true,
    postalInput: true,
    postalRequired: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '马来西亚'
  },
  'my_en': {
    country: '马来西亚',
    stateSelect: true,
    citySelectInline: true,
    postalInput: true,
    postalRequired: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '马来西亚'
  },
  'ph_en': {
    country: '菲律宾',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    postalInput: true,
    postalRequired: true
  },
  'sg_cn': {
    country: '新加坡',
    stateSelect: false,
    postalInput: true,
    postalRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '新加坡',
    autoFillCity: '新加坡'
  },
  'sg_en': {
    country: '新加坡',
    stateSelect: false,
    postalInput: true,
    postalRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '新加坡',
    autoFillCity: 'Singapore'
  },
  'hk_tc': {
    country: '香港',
    stateSelect: true,
    citySelectInline: true,
    streetSelect: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true
  },
  'hk_en': {
    country: '香港',
    stateSelect: true,
    citySelectInline: true,
    streetSelect: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true
  },
  'jp_jp': {
    country: '日本',
    stateSelect: true,
    cityInput: true,
    streetInput: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    jpRequired: true,
    jpSupply: true,
    emailInput: true
  },
  'ua_ar': {
    country: '阿联酋',
    stateSelect: true,
    cityInput: true,
    streetInput: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    alignRight: true
  },
  'ae_ar': {
    country: '阿联酋',
    stateSelect: true,
    citySelectInline: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    // emailRequired: true,
    alignRight: true,
    autoFillProvince: '阿联酋'
  },
  'sa_ar': {
    country: '沙特阿拉伯',
    stateSelect: true,
    // cityInput: true,
    citySelectInline: true,
    // streetInput: true,
    stateRequired: true,
    cityRequired: true,
    // streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    // emailRequired: true,
    alignRight: true,
    autoFillProvince: '沙特阿拉伯'
  },
  'ro_ro': {
    country: '罗马尼亚',
    stateSelect: true,
    citySearch: true,
    stateRequired: true,
    cityRequired: true,
    cityPostalSelect: true,
    postalRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    autoFillProvince: 'România'
  },
  'cz_cs': {
    country: '捷克',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'sk_sk': {
    country: '斯洛伐克',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'at_de': {
    country: '奥地利',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'hu_hu': {
    country: '匈牙利',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    cityDataZipcode: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    nameRegexp: true
  },
  'pl_pl': {
    country: '波兰',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'es_es': {
    country: '西班牙',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'it_it': {
    country: '意大利',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'gr_gr': {
    country: '希腊',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'pt_pt': {
    country: '葡萄牙',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'bg_bg': {
    country: '保加利亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'hr_hr': {
    country: '克罗地亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'sl_sl': {
    country: '斯洛文尼亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'lv_lv': {
    country: '拉脱维亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'lt_lt': {
    country: '立陶宛',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'ee_ee': {
    country: '爱沙尼亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'cy_cy': {
    country: '塞浦路斯',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'md_ro': {
    country: '摩尔多瓦',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'hr_eur_hr_eur': {
    country: '克罗地亚_欧元',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'kr_kr': {
    country: '韩国',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'srb_sr': {
    country: '塞尔维亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'al_sq': {
    country: '阿尔巴尼亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'tur_tr': {
    country: '土耳其',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'mx_mx': {
    country: '墨西哥',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'ma_ma': {
    country: '摩洛哥',
    stateSelect: true,
    citySearch: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'ua_ua': {
    country: '乌克兰',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalSelectInput: true,
    postalSelectInputCheck: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'pe_pe': {
    country: '秘鲁',
    stateSelect: true, // 选择州下拉框
    citySelect: true, // 选择城市下拉框
    streetSelect: true, // 选择街道下拉框
    postalSelect: true, // 选择邮编下拉框
    // postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    idCardRequired: true
  }
};

cl = getQueryVariable('cl', cl || 'tw_tc');
sessionStorage.setItem('cl', cl);
// cConf: 个人信息填写控制
window.cConf = templateConfigs[cl] || {};

function getQueryVariable(variable, defaultCl) {
  var ptList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(templateConfigs);
  var query = '';
  try {
    query = decodeURIComponent(window.location.search.substring(1)).replace(/&amp;/g, '&');
  } catch (e) {
    query = window.location.search.substring(1).replace(/&amp;/g, '&');
  }
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      if (ptList.indexOf(pair[1]) === -1) {
        return defaultCl;
      } else {
        return pair[1];
      }
    }
  }
  // window.location.search += ('&' + variable + '=' + defalut);
  return defaultCl;
}

// 用钩子函数beforeEach()对路由进行判断
__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 100);
  if (to.meta.requireAuth) {
    // 需要权限,进一步进行判断
    if (__WEBPACK_IMPORTED_MODULE_5__vuex_store_js__["a" /* default */].state.login.token) {
      // 通过vuex state获取当前的token是否存在
      next();
    } else {
      //如果没有权限,重定向到登录页,进行登录
      next({
        path: '/login'
        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    //不需要权限 直接跳转
    next();
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "S6md":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"double-bounce2"})]),_vm._v(" "),_c('p',[_vm._v("loading.....")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_permission__ = __webpack_require__("vZz+");





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
//按需加载,当渲染其他页面时才加载其组件,并缓存,减少首屏加载时间
var Index = function Index(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mlqX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Detail = function Detail(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/pee")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Pay = function Pay(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oU+0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Success = function Success(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zpnF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Search = function Search(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("G7FF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ShippingPolicy = function ShippingPolicy(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Imty")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var FAQ = function FAQ(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vNOy")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ReturnPolicy = function ReturnPolicy(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("o9Gk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PrivacyPolicy = function PrivacyPolicy(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LnMR")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Error = function Error(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xLdf")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Promotion = function Promotion(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pcSv")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myRouter = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: '首页',
    component: Index,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/detail',
    name: '详情页',
    component: Detail,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/pay',
    name: '支付页',
    component: Pay,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/success',
    name: '成功页',
    component: Success,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/search',
    name: '查询页',
    component: Search,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/shipping',
    name: '发货政策',
    component: ShippingPolicy,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/faq',
    name: '常见问题',
    component: FAQ,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/return',
    name: '退货政策',
    component: ReturnPolicy,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/privacy',
    name: '隐私政策',
    component: PrivacyPolicy,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/Promotion/:id',
    name: '活动页',
    component: Promotion,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/collections-big-sale',
    name: '活动页',
    component: Promotion,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }, {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      title: sessionStorage.seo_title,
      content: {
        keywords: sessionStorage.seo_keywords,
        description: sessionStorage.seo_description
      }
    }
  }]
});

myRouter.beforeEach(function (to, from, next) {
  if (to.matched.length === 0) {
    next({
      path: '/error',
      query: to.query
    });
    // 储存错误的路由地址，方便以后使用
    sessionStorage.errorUri = to.fullPath;
    return;
  }
  /* 路由发生变化修改页面meta */
  if (to.meta.content || sessionStorage.seo_keywords) {
    var head = document.getElementsByTagName('head');
    var meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords || sessionStorage.seo_keywords);
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description || sessionStorage.seo_description);
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title || sessionStorage.seo_title) {
    document.title = to.meta.title || sessionStorage.seo_title;
  }
  /* 路由切换时，如果没有就添加，有就跳过执行，添加固定参数 */
  var query = to.query;
  var queryCtrl = false;
  if (from.query.atm && !to.query.atm) {
    query.atm = from.query.atm;
    queryCtrl = true;
  }
  if (from.query.cl && !to.query.cl) {
    query.cl = from.query.cl;
    queryCtrl = true;
  }
  if (from.query.u && !to.query.u) {
    query.u = from.query.u;
    queryCtrl = true;
  }
  if (from.query.utm_source && !to.query.utm_source) {
    query.utm_source = from.query.utm_source;
    queryCtrl = true;
  }
  if (from.query.utm_medium && !to.query.utm_medium) {
    query.utm_medium = from.query.utm_medium;
    queryCtrl = true;
  }
  if (from.query.aid && !to.query.aid) {
    query.aid = from.query.aid;
    queryCtrl = true;
  }
  if (from.query.source && !to.query.source) {
    query.source = from.query.source;
    queryCtrl = true;
  }
  if (from.query.home && !to.query.home) {
    query.home = from.query.home;
    queryCtrl = true;
  }
  if (queryCtrl) {
    next({
      path: to.path,
      query: query
    });
  } else {
    next();
    var event_label = '';
    if (to.path === '/detail') {
      event_label = 'home';
    } else if (to.path === '/pay') {
      event_label = 'pay';
    } else if (to.path === '/search') {
      event_label = 'query';
    } else if (to.path === '/success') {
      event_label = 'success';
    }
    gtag('event', 'PageView', {
      event_category: window.location.href,
      event_label: event_label,
      value: startTime
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_permission__["c" /* mallSubmit */])({
      event_name: 'PageView',
      event_label: event_label
    });
    if (typeof snaptr === 'function') {
      try {
        snaptr('track', 'PAGE_VIEW');
      } catch (error) {
        console.log(error);
      }
    }
    if (window.isEnableTtqTrack()) {
      var eventId = localStorage.getItem('pageViewEventId') || window.guid();
      // 上报后删除事件id
      localStorage.removeItem('pageViewEventId');
      var ttq = window.ttq || {};
      var pixel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ttq._i || {})[0];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_permission__["d" /* commonApi */])("/api/tt/track", {
        pixel: pixel,
        request: {
          event_source: "web",
          event_source_id: pixel,
          data: [{
            event: "PageView",
            event_time: Math.floor(Date.now() / 1000),
            event_id: eventId,
            user: {
              ttclid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_permission__["e" /* getCookie */])("ttclid") || "",
              ttp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_permission__["e" /* getCookie */])("_ttp") || "",
              ip: "",
              user_agent: navigator.userAgent
            },
            page: {
              url: location.href
            }
          }]
        }
      }).catch(function (err) {
        console.log('err', err);
      });
    }
  }
});

myRouter.onError(function (err) {
  console.log('222');
  var pattern = /Loading chunk (\d)+ failed/g;
  var isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    var chunkBool = sessionStorage.getItem('chunkError');
    var nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) {
      //路由跳转报错,href手动跳转
      sessionStorage.setItem('chunkError', 'reload');
      var targetPath = myRouter.history.pending.fullPath;
      window.location.href = window.location.origin + targetPath;
    } else if (chunkBool === 'reload') {
      //手动跳转后依然报错,强制刷新
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (myRouter);

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_detail__ = __webpack_require__("yW3m");
//store.js



// 头部分类


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    detail: __WEBPACK_IMPORTED_MODULE_2__modules_detail__["a" /* default */]
  }
}));

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j1Ai":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m4jk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");





var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
// api.defaults.baseURL = '/api';
api.defaults.timeout = 25000;
api.defaults.headers.post['Content-Type'] = 'application/json';
api.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
api.defaults.loading = false;
// api.defaults.headers.post['sys-site-path'] = sessionStorage.getItem('cl');

// 请求拦截
api.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (config.loading) {
    __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', true);
  }
  // 如果有token,添加到请求报文 后台会根据该报文返回status
  return config;
}, function (error) {
  // 对请求错误做些什么
  alert('网络错误,请稍后再试');
  __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 添加响应拦截器
api.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);
  return response;
}, function (error) {
  // 对响应错误做点什么
  __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);
  if (error.response) {
    if (error.response.status === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('CHANGE_TOKEN', 0);
      alert('请重新登录');
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({
        path: 'login',
        query: { redirect: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.fullPath }
      });
    }
  }
  return error;
});
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ "meMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_HARDLOADING; });
/* Detail + Car*/

//全局loading状态
var SET_LOADING = 'SET_LOADING';
//全局loading状态
var SET_HARDLOADING = 'SET_HARDLOADING';

/***/ }),

/***/ "oI02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({direction: _vm.cConf.alignRight ? 'rtl' : ''}),attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('v-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.fetchLoading || _vm.hardLoading),expression:"fetchLoading || hardLoading"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vZz+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getQueryVariable */
/* harmony export (immutable) */ __webpack_exports__["e"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = langInfo;
/* harmony export (immutable) */ __webpack_exports__["m"] = getOnlineStatus;
/* harmony export (immutable) */ __webpack_exports__["o"] = getZipcode;
/* harmony export (immutable) */ __webpack_exports__["q"] = getZipcodeChild;
/* harmony export (immutable) */ __webpack_exports__["s"] = getSupply;
/* harmony export (immutable) */ __webpack_exports__["i"] = getFaq;
/* harmony export (immutable) */ __webpack_exports__["g"] = getPrivacyPolicy;
/* harmony export (immutable) */ __webpack_exports__["h"] = getReturnPolicy;
/* harmony export (immutable) */ __webpack_exports__["j"] = getShippingPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConfig;
/* harmony export (immutable) */ __webpack_exports__["n"] = shopDetail;
/* harmony export (immutable) */ __webpack_exports__["p"] = shopCreate;
/* harmony export (immutable) */ __webpack_exports__["k"] = search;
/* harmony export (immutable) */ __webpack_exports__["f"] = promotion;
/* harmony export (immutable) */ __webpack_exports__["u"] = getHomeItem;
/* harmony export (immutable) */ __webpack_exports__["t"] = getConfigInfo;
/* harmony export (immutable) */ __webpack_exports__["l"] = getRecommendProducts;
/* harmony export (immutable) */ __webpack_exports__["d"] = commonApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = mallSubmit;
/* harmony export (immutable) */ __webpack_exports__["r"] = errorCatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http_api__ = __webpack_require__("m4jk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_config_js__ = __webpack_require__("BK/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_experiment__ = __webpack_require__("/xfp");



// import md5 from 'js-md5';




function isSupportWebp() {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0 ? 1 : 0;
  } catch (err) {
    return 0;
  }
}

function objKeySort(arys) {
  var newkey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(arys).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = arys[newkey[i]];
  }
  return newObj;
}

function paramsProcess() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var timestamp = new Date().getTime();
  var tmp = JSON.parse(String(timestamp).substr(0, 10));
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    request_time: tmp
  }, params);
}

function getQueryVariable(variable) {
  var query = '';
  try {
    query = decodeURIComponent(window.location.search.substring(1)).replace(/&amp;/g, '&');
  } catch (e) {
    query = window.location.search.substring(1).replace(/&amp;/g, '&');
  }
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
}

function getCookie(variable) {
  var cookie = document.cookie;
  var vars = cookie.split(";").map(function (item) {
    return item.trim();
  });
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
}

/**
 * atm模板订单提交格式转换
 */
function atmFormat(params) {
  // 香港，日本，阿联酋，沙特atm地区为三级，其他为二级
  var areaDetail = cConf.autoFillProvince ? {
    province: cConf.autoFillProvince,
    city: params.state,
    area: params.city
  } : {
    province: params.state,
    city: params.city,
    area: params.street

    // let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/', 'https://www.cheapct.top/'];
  };var krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/'];

  if (krips.includes(location.origin + '/')) {
    // if (sessionStorage.cl === 'kr_kr') {
    return {
      user_info: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        name: params.uname,
        phone: params.phone,
        email: params.email,
        postal: params.postal,
        address: params.address,
        id_card: params.id_card
      }, areaDetail),
      user_note: params.guest,
      item_info: {
        combo_id: params.combo_id,
        final_price: params.total_price,
        count: 1,
        prostr: params.package
      },
      utm: {
        utm_source: getQueryVariable('utm_source'),
        u: getQueryVariable('u'),
        source: source
      },
      site_info: {
        // 本地地址处理和测试地址处理
        domain: location.host === 'localhost' ? 'www.tw51buygobuy.com' : location.host.replace('w3', 'www'),
        site_name: getQueryVariable('path'),
        item_hash: getQueryVariable('id'),
        cl: sessionStorage.cl
      },
      payment_info: {
        payment_method: 'PingPongCheckout'
      }
    };
  } else {
    return {
      user_info: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        name: params.uname,
        phone: params.phone,
        email: params.email,
        postal: params.postal,
        address: params.address,
        id_card: params.id_card
      }, areaDetail),
      user_note: params.guest,
      item_info: {
        combo_id: params.combo_id,
        final_price: params.total_price,
        count: 1,
        prostr: params.package
      },
      utm: {
        utm_source: getQueryVariable('utm_source'),
        u: getQueryVariable('u'),
        source: source
      },
      site_info: {
        // 本地地址处理和测试地址处理
        domain: location.host === 'localhost' ? 'www.tw51buygobuy.com' : location.host.replace('w3', 'www'),
        site_name: getQueryVariable('path'),
        item_hash: getQueryVariable('id'),
        cl: sessionStorage.cl
      }
    };
  }
}

function encodeForCloudFront(str) {
  return encodeURIComponent(str.normalize('NFD'));
}

/**
 * 语言模板信息
 * 每次更新json需要修改query参数v的值
 * @returns {AxiosPromise}
 */
function langInfo() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/language/' + type + '.json?v=1.5.2');
}

function getOnlineStatus(orderSn) {
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/cody/order/get?orderSn=' + orderSn);
}

/**
 * 获取地址和邮编json
 * 每次更新json需要修改query参数v的值
 * @returns {AxiosPromise}
 */
function getZipcode() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  if (sessionStorage.getItem("configData") && JSON.parse(sessionStorage.getItem("configData")).zipcodeType) {
    type = JSON.parse(sessionStorage.getItem("configData")).zipcodeType;
  }
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/zipcode/' + encodeForCloudFront(type) + '.json?v=1.4.9');
}
function getZipcodeChild() {
  var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sessionStorage.cl;

  if (sessionStorage.getItem("configData") && JSON.parse(sessionStorage.getItem("configData")).zipcodeType) {
    type = JSON.parse(sessionStorage.getItem("configData")).zipcodeType;
  }
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/zipcode/' + type + '/' + encodeForCloudFront(child) + '.json?v=1.4.9');
}

/**
 * 用户需知信息
 * 每次更新json需要修改query参数v的值
 * @returns {AxiosPromise}
 */
function getSupply() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/supply/' + type + '.json?v=1.3.6');
}

function getFaq() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/faq/' + type + '.json?v=1.3.8');
}

function getPrivacyPolicy() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  var hostname = window.location.hostname;
  if (hostname === 'www.cheapct.top') {
    return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/privacyPolicy/' + type + '_pay.json?v=1.3.9');
  } else {
    return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/privacyPolicy/' + type + '.json?v=1.3.7');
  }
}

function getReturnPolicy() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/returnPolicy/' + type + '.json?v=1.3.8');
}

function getShippingPolicy() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage.cl;

  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get("https://duw6x15mey27a.cloudfront.net" + '/static/shippingPolicy/' + type + '.json?v=1.3.8');
}

/**
 * 公共信息
 * @returns {AxiosPromise}
 * @public 刷新配置缓存接口：/codx/reload_config
 */
function getConfig() {
  var data = {
    item: getQueryVariable('id'),
    path: getQueryVariable('path'),
    cl: sessionStorage.cl
  };
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/codx' + (isAtm ? '/ab' : '') + '/item/config', { params: data, loading: true });
}

/**
 * 商品详情
 * @returns {AxiosPromise}
 */
function shopDetail(params) {
  var data = paramsProcess(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'is_support_webp': isSupportWebp() }, params));
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/codx' + (isAtm ? '/ab' : '') + '/item/detail', { params: data, loading: true });
}

/**
 * 下订单
 * @returns {AxiosPromise}
 */
function shopCreate(params, eventId, msg) {
  var newParams = paramsProcess(params);
  newParams.pit_c_k = getQueryVariable('u');
  if (msg === 'confirm') {
    newParams.guest += '（用户确认更新订单）';
  }
  if (cConf.thAddress) {
    newParams.address = newParams.town + newParams.address;
  }
  if (newParams.address2) {
    newParams.address = newParams.address + ",门牌号:" + newParams.address2;
  }
  var data = void 0;
  if (isAtm) {
    data = atmFormat(newParams);
  } else {
    data = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(newParams);
  }
  // let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/', 'https://www.cheapct.top/'];
  var krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/'];

  if (krips.includes(location.origin + '/')) {
    // if (sessionStorage.cl === 'kr_kr') {
    // todo 域名改为config.hostUrl
    return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/cody/order/placed', data, {
      headers: {
        'Content-Type': isAtm ? 'application/json' : 'application/x-www-form-urlencoded',
        'eventId': eventId,
        'pixelId': fb_id || '352985638959852'
      },
      loading: true
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/codx' + (isAtm ? '/ab' : '') + '/order/confirm' + (isAtm ? '' : '2'), data, {
      headers: {
        'Content-Type': isAtm ? 'application/json' : 'application/x-www-form-urlencoded',
        'eventId': eventId,
        'pixelId': fb_id || '352985638959852'
      },
      loading: true
    });
  }
}

/**
 * 订单查询
 * @returns {AxiosPromise}
 */
function search(params) {
  var data = paramsProcess(params);
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/codx' + (isAtm ? '/ab' : '') + '/order/query', {
    params: data,
    loading: true
    // headers: {
    //   'sys-site-sn': md5(md5(JSON.stringify(objKeySort(data)) + "Ino9LhvD52FxPcSbt4WyH3zdkCXN7agE")),
    //   'sys-site-path':sessionStorage.cl
    // }
  });
}

/**
 * 活动页面
 * @param params
 * @return {AxiosPromise}
 */
function promotion(params) {
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/codx/shopify/promotion', {
    params: params,
    loading: true
  });
}

/**
 * 首页
 * @param params
 * @return {AxiosPromise}
 */
function getHomeItem(params) {
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + '/codx/home?configName=\u9ED8\u8BA4\u914D\u7F6E', {
    params: params,
    loading: false
  });
}

/**
 * 首页
 * @param params
 * @return {AxiosPromise}
 */
function getConfigInfo(domain) {
  // 域名集合，google域名访问链接为页面url（tower：）
  var ggDomains = ['recommenddaily.top', 'studentmo.top', 'trendnewlife.top', 'felicityman.top', 'yousuperbcool.top', 'stayvogue.top', 'sportwoek.top', 'tihappy.top', 'premiummo.top', 'happylo.top', 'stopresearch.top', 'conhappy.top', 'stoppartners.top', 'stopconnect.top', 'fashionedclothing.com', 'indianhappy.top', 'fahappy.top', 'vahappy.top', 'gehappy.top', 'rohappy.top', 'spstop.top', 'mpstop.top', 'bohappy.top', 'moology.top', 'chstop.top', 'lkwear.top', 'sydirectory.top', 'qualitysy.top', 'californiasy.top', 'easyoy.top', 'syresources.top', 'ladysy.top', 'chicystore.com', 'yinghapp.com', 'drwor.top', 'manlk.top', 'namecr.top', 'rockcr.top', 'trafficen.top', 'tlline.top', 'citytl.top', 'domainox.top', 'shoplifego.com', 'romanticorner.com', 'greetedshop.com', 'gracetiro.com', 'pitting.top', 'lackbag.com', 'colorfulskirt.com', 'indiansb.top', 'freedomle.top', 'leeye.top', 'beachle.top', 'lefriends.top', 'minisb.top', 'goldensb.top', 'sbsale.top', 'familysb.top', 'energysb.top', 'ultimatesb.top', 'geosb.top', 'bodysb.top', 'safesb.top', 'crazysb.top', 'worksb.top', 'zensb.top', 'crazysb.top', 'girlct.top', 'cherishes.top', 'shop.sboutique.top', 'www.recommenddaily.top', 'www.studentmo.top', 'www.trendnewlife.top', 'www.felicityman.top', 'www.yousuperbcool.top', 'www.stayvogue.top', 'www.sportwoek.top', 'www.tihappy.top', 'www.premiummo.top', 'www.happylo.top', 'www.stopresearch.top', 'www.conhappy.top', 'www.stoppartners.top', 'www.stopconnect.top', 'www.fashionedclothing.com', 'www.indianhappy.top', 'www.fahappy.top', 'www.vahappy.top', 'www.gehappy.top', 'www.rohappy.top', 'www.spstop.top', 'www.mpstop.top', 'www.bohappy.top', 'www.moology.top', 'www.chstop.top', 'www.lkwear.top', 'www.sydirectory.top', 'www.qualitysy.top', 'www.californiasy.top', 'www.easyoy.top', 'www.syresources.top', 'www.ladysy.top', 'www.chicystore.com', 'www.yinghapp.com', 'www.drwor.top', 'www.manlk.top', 'www.namecr.top', 'www.rockcr.top', 'www.trafficen.top', 'www.tlline.top', 'www.citytl.top', 'www.domainox.top', 'www.shoplifego.com', 'www.romanticorner.com', 'www.greetedshop.com', 'www.gracetiro.com', 'www.pitting.top', 'www.lackbag.com', 'www.colorfulskirt.com', 'qymagazine.top', 'assigning.top', 'www.qymagazine.top', 'www.assigning.top', 'www.indiansb.top', 'www.freedomle.top', 'www.leeye.top', 'www.beachle.top', 'www.lefriends.top', 'www.minisb.top', 'www.goldensb.top', 'www.sbsale.top', 'www.familysb.top', 'www.energysb.top', 'www.ultimatesb.top', 'www.geosb.top', 'www.bodysb.top', 'www.safesb.top', 'www.crazysb.top', 'www.worksb.top', 'www.zensb.top', 'www.crazysb.top', 'www.shinne.top', 'www.fashionles.top', 'www.nosycloth.top', 'www.josclub.top', 'www.oldstore.top', 'www.greetshop.top', 'www.girlct.top', 'www.cherishes.top', 'www.shop.sboutique.top'];
  var url = '/api/getConfigByDomain?domain=' + domain.domain;
  if (ggDomains.indexOf(domain.domain) >= 0) {
    url = '' + __WEBPACK_IMPORTED_MODULE_3__util_config_js__["a" /* default */].hostUrl + url;
  } else {
    url = "https://da.cartgo.cloud" + url;
  }
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(url, {
    // return axios.get(`https://da.cartgo.cloud/api/getConfigByDomain?domain=${domain.domain}`, {
    // return axios.get(`${config.hostUrl}/api/getConfigByDomain?domain=${domain.domain}`, {
    loading: false
  });
}

/**
 * 获取推荐列表
 * @param params
 * @return {AxiosPromise}
 */
function getRecommendProducts(params) {
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get('https://open.cartx.ai/api/out/recommend/products', {
    params: params,
    loading: false
  });
}

function commonApi(path, params) {
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].post('https://da.cartgo.cloud' + path, params);
}

/**
 * 埋点
 * @returns
 */
function mallSubmit(params) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_experiment__["a" /* isDisableTrackM */])()) {
    return;
  }

  var mallUrl = "/m";

  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, {
    time_stamp: Date.now(),
    cl: sessionStorage.cl,
    user_ID: document.cookie ? getCookie('USERKEY') : '',
    UA: navigator.userAgent,
    campaign_ID: getQueryVariable('u'),
    experiment: document.cookie ? getCookie('STRATEGYKEY') : '',
    session_ID: sessionStorage.sessionId,
    utm_source: getQueryVariable('utm_source'),
    utm_medium: getQueryVariable('utm_medium'),
    ad_id: getQueryVariable('aid'),
    url: window.location.href
  });
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get(mallUrl, { params: data });
}

function errorCatch(params) {
  return __WEBPACK_IMPORTED_MODULE_2__http_api__["a" /* default */].get('static/error', {
    params: params,
    loading: false
  });
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_permission__ = __webpack_require__("vZz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_loading__ = __webpack_require__("44dg");




//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "v-loading": __WEBPACK_IMPORTED_MODULE_5__components_common_loading__["a" /* default */]
  },
  data: function data() {
    return {
      cConf: cConf
    };
  },

  computed: {
    fetchLoading: function fetchLoading() {
      return this.$store.state.detail.fetchLoading;
    },
    hardLoading: function hardLoading() {
      return this.$store.state.detail.hardLoading;
    }
  },
  created: function created() {
    this.getLang();
    this.getConfig();
  },

  methods: {
    getLang: function getLang() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var lang;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["a" /* langInfo */])();

              case 2:
                lang = _context.sent;

                sessionStorage.setItem('lang', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ cl: sessionStorage.cl }, lang.data.data)));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getConfig: function getConfig() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var configData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["b" /* getConfig */])();

              case 2:
                configData = _context2.sent.data;

                if (configData && configData.message === 'success') {
                  sessionStorage.setItem('configData', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ cl: sessionStorage.cl }, configData.data)));
                  sessionStorage.seo_keywords = configData.data.seo_title;
                  sessionStorage.seo_title = configData.data.seo_title;
                  sessionStorage.seo_description = configData.data.seo_title;
                  sessionStorage.email = configData.data.email;
                  document.querySelector('meta[name="keywords"]').setAttribute('content', sessionStorage.seo_keywords);
                  document.querySelector('meta[name="description"]').setAttribute('content', sessionStorage.seo_description);
                  document.title = sessionStorage.seo_title;
                  document.querySelector('meta[property="og:title"]').setAttribute('content', sessionStorage.seo_title);
                  document.querySelector('meta[property="og:description"]').setAttribute('content', sessionStorage.seo_description);
                  document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
                  document.querySelector('meta[property="og:image"]').setAttribute('content', sessionStorage.seo_img);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "yW3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_config__ = __webpack_require__("BK/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");


var _mutations;





// 容器
var state = {
  fetchLoading: false, //全局加载状态的Loading
  hardLoading: false //全局加载状态的Loading
};

//更改 store 中的状态的唯一方法:提交 mutation

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* SET_LOADING */], function (state, res) {
  state.fetchLoading = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_HARDLOADING */], function (state, res) {
  state.hardLoading = res;
}), _mutations);

var vm = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({});

// action提交mutations，不直接更改状态（通过store.dispatch触发）
var actions = {

  // 购物车数量增减,true是加,false是减
  //   setLocalCount({commit},bool = true) {
  //     let count = Util.getLocal('count') || 0;
  //     if(bool) {
  //       Util.setLocal(++count,'count');
  //     }else {
  //         Util.setLocal(--count,'count');
  //     }
  //     commit(types.CHANGE_COUNT);
  //   },
};

// 如同计算属性,处理state的某个状态
var getters = {

  // selectedList(state) {
  //     // choseBool为真的商品 即打钩的商品
  //    if(state.carList!=='') {
  //      let arr = state.carList.filter((ele)=>{
  //        return ele.choseBool == true
  //      });
  //      return arr
  //    }
  // },
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3ebb668c4c0f9acf2038.js